import type { JSX } from 'react';

import { InnerCircle, LoadingSpinnerWrapper, OuterCircle } from './styled';
import type { LoadingSpinnerProps } from './types';

export function LoadingSpinner({
  className = '',
  size = 70,
  color = '#fff',
  absolute = false,
}: LoadingSpinnerProps): JSX.Element {
  return (
    <LoadingSpinnerWrapper className={className} absolute={absolute} data-testid="loading.spinner">
      <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="25 25 50 50">
        <OuterCircle id="outer" cx="50" cy="50" r="20" color={color}>
          <animateTransform
            attributeName="transform"
            dur="2s"
            from="0 50 50"
            repeatCount="indefinite"
            to="360 50 50"
            type="rotate"
          />
        </OuterCircle>
        <InnerCircle id="inner" cx="50" cy="50" r="15" color={color}>
          <animateTransform
            attributeName="transform"
            dur="2s"
            from="0 50 50"
            repeatCount="indefinite"
            to="360 50 50"
            type="rotate"
          />
        </InnerCircle>
      </svg>
    </LoadingSpinnerWrapper>
  );
}
